export default "__VITE_ASSET__fb052f2c__"